import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { CommonModule } from '@angular/common';
import { InicioComponent } from './inicio/inicio.component';
import { FooterComponent } from './footer/footer.component';
import { NavmenuComponent } from './navmenu/navmenu.component';
import { SplashComponent } from './splash/splash.component';
import { QuienessomosComponent } from './quienessomos/quienessomos.component';
import { OrganigramaComponent } from './organigrama/organigrama.component';
import { SliderimpactoComponent } from './sliderimpacto/sliderimpacto.component';
import { Splash2Component } from './splash2/splash2.component';
import { VoluntariadoComponent } from './voluntariado/voluntariado.component';
import { FormacionComponent } from './formacion/formacion.component';
import { QuehacemosComponent } from './quehacemos/quehacemos.component';


const routes: Routes = [
    // REDIRECCIÓN
    { path: '', redirectTo: 'inicio', pathMatch: 'full' },
    { path: '', component: InicioComponent },
    { path: 'footer', component: FooterComponent },
    // PROTOTIPO
    { path: 'navmenu', component: NavmenuComponent },
    { path: 'splash', component: SplashComponent },
    { path: 'quienessomos', component: QuienessomosComponent },
    { path: 'quehacemos', component: QuehacemosComponent },
    { path: 'organigrama', component: OrganigramaComponent },
    { path: 'sliderimpacto', component: SliderimpactoComponent },
    { path: 'splash2', component: Splash2Component },
    { path: 'voluntariado', component: VoluntariadoComponent },
    { path: 'formacion', component: FormacionComponent },
    // REDIRECCIÓN
    { path: '**', redirectTo:'' },
];

@NgModule({
    declarations: [],
    imports: [
        //RouterModule.forRoot(routes),
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'disabled' })
        ],
        exports: [RouterModule]
    })
    export class AppRoutingModule { }